<div class="gw-space-y-6 gw-p-x-large gw-max-w-lg">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="gw-space-y-4">
      <p class="gw-text-text-primary gw-text-base">
        {{ 'features.settings.parameters.tracking.description' | translate }}
      </p>

      <section class="gw-space-y-4">
        <h3 class="gw-text-text-primary gw-text-sm gw-font-medium">
          {{ 'features.settings.parameters.tracking.clientTitle' | translate }}
        </h3>
        <p class="gw-text-text-secondary gw-text-sm">
          {{ 'features.settings.parameters.tracking.clientHint' | translate }}
        </p>
        <gatewee-input-v2
          [form]="formGroup"
          controlName="client.ga4MeasurementId"
          [label]="
            'features.settings.parameters.tracking.ga4MeasurementId.label'
              | translate
          "
          [placeholder]="
            'features.settings.parameters.tracking.ga4MeasurementId.placeholder'
              | translate
          "
          id="tracking-ga4MeasurementId"
          type="text"
        ></gatewee-input-v2>
        <gatewee-input-v2
          [form]="formGroup"
          controlName="client.metaPixelId"
          [label]="
            'features.settings.parameters.tracking.metaPixelId.label'
              | translate
          "
          [placeholder]="
            'features.settings.parameters.tracking.metaPixelId.placeholder'
              | translate
          "
          id="tracking-metaPixelId"
          type="text"
        ></gatewee-input-v2>
        <gatewee-input-v2
          [form]="formGroup"
          controlName="client.tiktokPixelId"
          [label]="
            'features.settings.parameters.tracking.tiktokPixelId.label'
              | translate
          "
          [placeholder]="
            'features.settings.parameters.tracking.tiktokPixelId.placeholder'
              | translate
          "
          id="tracking-tiktokPixelId"
          type="text"
        ></gatewee-input-v2>
      </section>

      <section class="gw-space-y-4 gw-pt-4 gw-border-t gw-border-border">
        <h3 class="gw-text-text-primary gw-text-sm gw-font-medium">
          {{ 'features.settings.parameters.tracking.serverTitle' | translate }}
        </h3>
        <p class="gw-text-text-secondary gw-text-sm">
          {{ 'features.settings.parameters.tracking.serverHint' | translate }}
        </p>
        <gatewee-input-v2
          [form]="formGroup"
          controlName="server.ga4ApiSecret"
          [label]="
            'features.settings.parameters.tracking.ga4ApiSecret.label'
              | translate
          "
          [placeholder]="
            'features.settings.parameters.tracking.ga4ApiSecret.placeholder'
              | translate
          "
          id="tracking-ga4ApiSecret"
          type="password"
        ></gatewee-input-v2>
        <gatewee-input-v2
          [form]="formGroup"
          controlName="server.metaConversionsApiToken"
          [label]="
            'features.settings.parameters.tracking.metaConversionsApiToken.label'
              | translate
          "
          [placeholder]="
            'features.settings.parameters.tracking.metaConversionsApiToken.placeholder'
              | translate
          "
          id="tracking-metaConversionsApiToken"
          type="password"
        ></gatewee-input-v2>
        <gatewee-input-v2
          [form]="formGroup"
          controlName="server.tiktokEventsApiToken"
          [label]="
            'features.settings.parameters.tracking.tiktokEventsApiToken.label'
              | translate
          "
          [placeholder]="
            'features.settings.parameters.tracking.tiktokEventsApiToken.placeholder'
              | translate
          "
          id="tracking-tiktokEventsApiToken"
          type="password"
        ></gatewee-input-v2>
      </section>
    </div>

    <div class="gw-flex gw-justify-end gw-gap-3 gw-mt-6">
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (clicked)="close()"
        [disabled]="submitting"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="'common.actions.save' | translate"
        type="submit"
        [disabled]="submitting"
      ></gatewee-button>
    </div>
  </form>
</div>
